/**
 * Uitloggen na inactiviteit (spec 2026-10-24-urenregistratie, besluit 23). De laatste klik, toets,
 * scroll of aanraking telt, over alle tabbladen heen: elk tabblad schrijft hem in `localStorage`
 * en leest de nieuwste terug. Puur, zodat het zonder DOM te toetsen is.
 */
export const IDLE_STORAGE_KEY = 'erp:last-activity'
/** Zo vaak kijkt een tabblad of de tijd om is; ook na een slaapstand, bij de eerste tik. */
export const IDLE_CHECK_MS = 15_000
/** Hooguit zo vaak schrijft een tabblad zijn activiteit weg. */
export const IDLE_WRITE_MS = 5_000

export function idleExpired(lastActivity: number, minutes: number | null, now: number): boolean {
  return minutes !== null && now - lastActivity >= minutes * 60_000
}

/** De nieuwste activiteit: die van dit tabblad of die uit de opslag, wat het laatst was. */
export function latestActivity(local: number, stored: string | null): number {
  const other = stored ? Number(stored) : Number.NaN
  return Number.isFinite(other) && other > local ? other : local
}
